import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.css';

export const Slide = ({ children, isActive, duration = 1000, afterSlideExit }) => {
  const className = isActive ? 'slideInUp' : 'slideOutDown';
  const noop = () => {};
  const afterExit = afterSlideExit || noop;

  if (!isActive) {
    setTimeout(afterExit, duration * 0.8);
  }

  return (
    <div
      style={{ animationDuration: `${duration}ms` }}
      className={[style.container, style[className]].join(' ')}
    >
      {children}
    </div>
  );
};

Slide.propTypes = {
  afterSlideExit: PropTypes.func,
  children: PropTypes.element,
  isActive: PropTypes.bool,
  duration: PropTypes.number,
};

export default Slide;
